import { BlockFooter } from '@medifind/containers';
import { IconArrowSmall } from '@medifind/icons';
import { MFLink } from '@medifind/shared-basic-components';
import styles from './ViewAllFooter.module.scss';

const ViewAllFooter = ({ to, label }) => {
  return (
    <BlockFooter className={styles['widget-footer']} addBorder>
      <MFLink to={to} className={styles['view-all']}>
        View All {label && label} <IconArrowSmall />
      </MFLink>
    </BlockFooter>
  );
};

export { ViewAllFooter as default, ViewAllFooter };
